import {COURSES,COURSE_ORDER,type CourseId} from '../../shared/math/course-catalog';
// Picker order is the catalog's section order (course-catalog.ts), the same definitions as section membership.
const rank=(id:CourseId)=>{const index=COURSE_ORDER.indexOf(id);return index<0?COURSE_ORDER.length:index;};
export {courseLabel} from '../../shared/math/course-label';
export function visibleCourses(current?:CourseId){return COURSES.filter(c=>c.id!=='early'||current==='early').slice().sort((a,b)=>rank(a.id)-rank(b.id));}
export function previewCourseFromUrl(url:string):CourseId{
 const id=new URL(url,'http://localhost').searchParams.get('course');return visibleCourses().find(c=>c.id===id)?.id??'algebra';
}
export function coursePreviewUrl(url:string,course:CourseId){
 if(!visibleCourses().some(c=>c.id===course))throw new Error('Unknown preview course');
 const next=new URL(url,'http://localhost');next.searchParams.set('course',course);return next.pathname+next.search+next.hash;
}
export function replacePreviewCourse(window:Pick<Window,'location'|'history'>,course:CourseId){
 const next=coursePreviewUrl(window.location.href,course),current=new URL(window.location.href);
 if(next!==current.pathname+current.search+current.hash)window.history.replaceState(window.history.state,'',next);
}
export function watchPreviewHistory(window:Pick<Window,'location'|'addEventListener'|'removeEventListener'>,changed:(course:CourseId)=>void){
 const onHistory=()=>changed(previewCourseFromUrl(window.location.href));window.addEventListener('popstate',onHistory);return()=>window.removeEventListener('popstate',onHistory);
}
